import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { notification, Typography } from 'antd';
import { useAuthService } from '../../services/authService';
import { useAuth } from '../../context/AuthContext';
import { notificationType } from '../../common/constants/notificationType';
import { routesPath } from '../../common/constants/routesPath';
import classes from '../../common/styles/FormStyles.module.scss';
import TwoFactorAuthForm from '../../components/auth/TwoFactorAuthForm.js';
import { useTranslation } from 'react-i18next';
import { redirectWithSearchParams } from '../../utils/redirectWithSearchParams.js';
import logo from '../../assets/check-vin-logo.png';
import { useMedia } from '../../hooks/useMediaQuery';

export default function TwoFactorAuth() {
    const [api, contextHolder] = notification.useNotification();
    const navigate = useNavigate();
    const { t } = useTranslation(['settings', 'apiResponses']);
    const [searchParams] = useSearchParams();
    const { isSmallDevice } = useMedia();
    const { twoFactorAuth } = useAuthService();
    const { setAuth } = useAuth();
    const [loading, setLoading] = useState(false);

    const openNotification = ({ type = 'error', message = '', description = '', placement = 'top' }) => {
        api[type]({
            message: message,
            description: description,
            placement: placement,
        });
    };

    const onBackClick = () => {
        setAuth(null, null);
        navigate(routesPath.AUTH.PATH);
    };

    const onFormSubmit = async form => {
        try {
            setLoading(true);
            const twoFactorTokens = await twoFactorAuth(form.code);

            if (twoFactorTokens?.data) {
                const { accessToken, refreshToken } = twoFactorTokens.data;
                setAuth(accessToken, refreshToken);

                redirectWithSearchParams(navigate, searchParams, routesPath.ROOT.DASHBOARD);
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
            const code = error.response?.data?.code;
            openNotification({
                type: notificationType.ERROR,
                message: code ? t(`apiResponses:${code}.message`) : error.response?.status,
                description: code ? t(`apiResponses:${code}.description`) : error.response?.statusText,
            });
        }
    };

    return (
        <div className={classes['auth-wrapper']} style={{ gap: 0 }}>
            {contextHolder}
            <div className={classes['auth-card']}>
                <img src={logo} alt="CheckVIN.ai" className={classes.logo} />
                <h3 style={{ marginBottom: '-12px', fontSize: isSmallDevice && 26 }}>{t('settings:2FA-title')}</h3>
                <div className={classes.content}>
                    <Typography.Text className={classes.text}>{t('settings:2FA.page.description')}</Typography.Text>
                    <TwoFactorAuthForm
                        loading={loading}
                        showCancel={true}
                        submitDisabled={false}
                        onBackClick={onBackClick}
                        onFormSubmit={onFormSubmit}
                        t={t}
                    />
                </div>
            </div>
        </div>
    );
}
